<!--suppress ALL -->
<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form>
          <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id">
            <div class="form-group row" v-if="phoenix_setting.setting === 'PRE_ANNOUNCE.ENABLED'">
              <label class="col-4 col-form-label">Intercom Pre-Announce</label>
              <div class="col-6">
                <select class="form-control" v-model="phoenix_setting.value">
                  <option value="1">On</option>
                  <option value="0">Off</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'PRE_ANNOUNCE.VOLUME'">
              <label class="col-4 col-form-label">Intercom Pre-Announce Volume</label>
              <div class="col-6">
                <select class="form-control" v-model="phoenix_setting.value">
                  <option value="0">0 (Max)</option>
                  <option value="-5">-5</option>
                  <option value="-10">-10</option>
                  <option value="-15">-15</option>
                  <option value="-20">-20</option>
                  <option value="-25">-25</option>
                  <option value="-30">-30</option>
                  <option value="-35">-35</option>
                  <option value="-40">-40</option>
                  <option value="-45">-45</option>
                  <option value="-50">-50</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'PRE_ANNOUNCE.TONE'">
              <label class="col-4 col-form-label">Intercom Pre-Announce Tone</label>
              <div class="col-6">
                <select class="form-control" v-model="phoenix_setting.value">
                  <option value="1000">1000 Hz</option>
                  <option value="900">900 Hz</option>
                  <option value="800">800 Hz</option>
                  <option value="700">700 Hz</option>
                  <option value="600">600 Hz</option>
                  <option value="500">500 Hz</option>
                  <option value="400">400 Hz</option>
                  <option value="300">300 Hz</option>
                  <option value="200">200 Hz</option>
                </select>
              </div>
            </div>
            <b v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_INTERCOM.CONDITION'">school_sipcall_intercom</b>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_INTERCOM.CONDITION'">
              <label for="txtSIPIntercomCondition" class="col-4 col-form-label">Condition</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPIntercomCondition"
                v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_INTERCOM.TYPE'">
              <label for="ddlSIPIntercomType" class="col-4 col-form-label">Type</label>
              <div class="col-8">
                <select class="form-control" id="ddlSIPIntercomType"
                       v-model="phoenix_setting.value">
                  <option value="non-gateway">Non-Gateway</option>
                  <option value="gateway">Gateway</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_INTERCOM.GATEWAY_BRIDGE_DATA'">
              <label for="txtSIPIntercomGatewayData" class="col-4 col-form-label">Gateway</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPIntercomGatewayData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_INTERCOM.NON_GATEWAY_BRIDGE_DATA'">
              <label for="txtSIPIntercomNonGatewayData" class="col-4 col-form-label">Non-Gateway</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPIntercomNonGatewayData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <b v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_EMERGENCY.CONDITION'">school_sipcall_emergency</b>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_EMERGENCY.CONDITION'">
              <label for="txtSIPEmergencyCondition" class="col-4 col-form-label">Condition</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPEmergencyCondition"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_EMERGENCY.TYPE'">
              <label for="ddlSIPEmergencyType" class="col-4 col-form-label">Type</label>
              <div class="col-8">
                <select class="form-control" id="ddlSIPEmergencyType"
                        v-model="phoenix_setting.value">
                  <option value="non-gateway">Non-Gateway</option>
                  <option value="gateway">Gateway</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_EMERGENCY.GATEWAY_BRIDGE_DATA'">
              <label for="txtSIPEmergencyGatewayData" class="col-4 col-form-label">Gateway</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPEmergencyGatewayData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_CALL_EMERGENCY.NON_GATEWAY_BRIDGE_DATA'">
              <label for="txtSIPEmergencyNonGatewayData" class="col-4 col-form-label">Non-Gateway</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtSIPEmergencyNonGatewayData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" v-if="[3].includes(logged_in_user.group_id)">Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      phoenix_settings: 'allPhoenixSettings',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.INTERCOM.DIAL_PLAN.DEFAULT')
  },
  methods: {
    submit () {
      this.$store.dispatch('editPhoenixSettings', this.phoenix_settings)
    }
  }
}
</script>

<style scoped>

</style>
